import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ProductBadgeComponent } from '@product-catalogue/src/lib/category-shared/product-badge/product-badge.component';
import { ProductFeatures, SanityProduct } from '@gelato-api-ui/core/sanity/sanity-product';
import { ProductFeatureBadgeComponent } from '@product-catalogue/src/lib/category-shared/product-feature-badge/product-feature-badge.component';

@Component({
  standalone: true,
  selector: 'lib-product-badges-container',
  templateUrl: './product-badges-container.component.html',
  styleUrls: ['./product-badges-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, ProductBadgeComponent, ProductFeatureBadgeComponent],
})
export class ProductBadgesContainerComponent {
  @Input() product: SanityProduct;

  get showBadges(): boolean {
    return !!this.product?.productBadge || this.hasMountedFramedPosters || this.hasEmbroidery;
  }

  get hasEmbroidery(): boolean {
    return this.product.productFeatures?.includes(ProductFeatures.embroidery);
  }

  get hasMountedFramedPosters(): boolean {
    return this.product.productFeatures?.includes(ProductFeatures.mountedFramedPosters);
  }
}
